<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="title">{{ $t('ARTWORK.ASK_US')}}</span>
        <v-spacer />
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text>
        <v-form @submit.prevent="submit" class="px-3">
          <v-text-field
            :label="$t('COMMON.NAME')"
            v-model="form.name"
            :error-messages="errors.name"
          />
          <v-text-field
            :label="$t('COMMON.EMAIL')"
            v-model="form.email"
            type="email"
            :error-messages="errors.email"
          />
          <v-textarea
            v-model="form.question"
            rows="1"
            :label="$t('COMMON.QUESTION')"
            :error-messages="errors.question"
            :hint="hint"
            persistent-hint
            auto-grow
          />

          <div class="text-xs-right mt-3">
            <tk-btn
              v-if="showAlreadyCodeBtn"
              :loading="loading"
              type="button"
              @click="$emit('hasCode'); $emit('input', !value)"
            >{{ $t("CART.SHIPPING_CODE_ALREADY_BTN") }}</tk-btn>
            <tk-btn :loading="loading" color="primary" type="submit">{{ $t("COMMON.SUBMIT") }}</tk-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useGTag } from '../../services/google/google-tag-manager'

export default {
  props: {
    value: { type: Boolean, required: true },
    topic: { type: "taiko" | "shipping" | "request" | 'commission', required: true },
    showAlreadyCodeBtn: { type: Boolean, default: false },
    artwork_id: { default: null },
    country_id: { default: null }
  },

  data() {
    return {
      loading: false,
      form: { topic: this.topic },
      errors: {}
    };
  },

  computed: {
    hint() {
      return this.$t(`ASK_US.${this.topic.toUpperCase()}.HELP`);
    }
  },

  methods: {
    async submit() {
      this.errors = {};
      this.loading = true;

      try {
        if (this.artwork_id) this.form.artwork_id = this.artwork_id;
        if (this.country_id) this.form.country_id = this.country_id;
        await this.$axios.post("/contact", this.form);
        if(this.topic === 'commission') {
          useGTag().submitCommission(this.form)
        }

        this.$emit("input", false);

        this.$app.toast(this.$t("ASK_US.SUCCESS_MSG"), 3000);
      } catch (error) {
        if (error.status === 422 && error.data) {
          this.errors = error.data.errors;
          console.log(this.errors);
        }
      }

      this.loading = false;
    }
  }
};
</script>

